import { useState, useEffect } from 'react';

const useCompanyServicesUsed = (entity) => {
  const [companyServices, setCompanyServices] = useState([]);

  useEffect(() => {
    if (Boolean(entity?.companyServices?.length)) {
      const companyServices = entity.companyServices;

      const usedCompanyServices = companyServices.filter(
        (service) => service.isUse
      );

      setCompanyServices(usedCompanyServices);
    }
  }, [entity]);

  return companyServices;
};

export default useCompanyServicesUsed;
